const routes = [
    {
        path: "/document/request/form",
        component: () => import("../pages/student/DocumentRequestForm"),
        meta: {
            isAuthenticated: true,
            permission: "documentrequest_studentform"
        },
        component_full_path: 'documentRequest/pages/student/DocumentRequestForm'
    },
    {
        path: "/document/requests",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'documentrequest_index',
        },

    },
    {
        path: "/document/requests/ebys/diploma",
        component: () => import("../pages/DiplomaEbysSend"),
        meta: {
            isAuthenticated: true,
            //permission: 'documentrequest_diploma',
        }
    },
    {
        path: "/document/requests/ebys/minor-certificate",
        component: () => import("../pages/MinorCertificate"),
        meta: {
            isAuthenticated: true,
            //permission: 'documentrequest_diploma',
        }
    }
]

export default routes;
